import { ICreateOrder } from '../../../../../orders/Entities';

export const PhotographerBookingParamsStorageKey = 'PhotographerBookingParams';

export type OrderInfoFromBookingFlow = {
    address: {
        city: string;
        street: string;
        zip: string;
    };
    selectedProductIds: string;
    brokerFirmId: number;
    orderInformation: ICreateOrder;
};

export function storeBookingInformationBetweenNavigation(
    orderInformation: ICreateOrder,
    address,
    selectedProducts: number[],
    selectedBrokerFirm: any
) {
    window.localStorage.setItem(
        PhotographerBookingParamsStorageKey,
        JSON.stringify({
            searchParams: {
                city: address.addressCity,
                street: address.addressLine1,
                zip: address.addressPostalNumber,
                p: selectedProducts.join(','),
                bfid: selectedBrokerFirm.id
            },
            orderInformation
        })
    );
}

export function getBookingInformationFromBetweenNavigation(): OrderInfoFromBookingFlow {
    let orderInformation = null;
    let city = '';
    let street = '';
    let zip = '';
    let selectedProductIds = '';
    let brokerFirmId = '';

    try {
        let storedBookingInformationString = window.localStorage.getItem(
            PhotographerBookingParamsStorageKey
        );

        let storedBookingInformation = JSON.parse(storedBookingInformationString);
        let storedParams = storedBookingInformation.searchParams;

        orderInformation = storedBookingInformation.orderInformation;

        city = storedParams.city;
        street = storedParams.street;
        zip = storedParams.zip;

        selectedProductIds = storedParams.p;
        brokerFirmId = storedParams.bfid;
    } catch (error) {
        window.localStorage.removeItem(PhotographerBookingParamsStorageKey);
        throw new Error('Error parsing stored booking information');
    }

    return {
        address: {
            street,
            city,
            zip
        },
        selectedProductIds,
        brokerFirmId: Number(brokerFirmId),
        orderInformation
    };
}
